import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { styled } from '@mui/material/styles';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../../components/common/page/Homepage/FestivalSlider/Slideshow.css';
import { getDefaultMenu } from './../../../../services/api/MenuAPI';
import GetQuotationForm from './GetQuotationForm';
import MenuCard from './MenuCard';
import './DefaultMenuCard.css';

const Slide = styled(Box)(() => ({
	width: '100%',
	position: 'relative',
	overflow: 'hidden',
}));

const MenuContainer2: React.FC = () => {
	const [menus, setMenus] = useState<any[]>([]);
	const [formOpen, setFormOpen] = useState(false);
	const [selectedMenuId, setSelectedMenu] = useState('');
	const [selectedEvent, setSelectedEvent] = useState('');

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await getDefaultMenu();
				if (response?.success) {
					setMenus(response.data.menus);
				}
			} catch (error) {
				console.error('Error fetching menu:', error);
			}
		};
		fetchData();
	}, []);

	const handleClose = () => setFormOpen(false);

	const handleOpen = (defaultMenuId: string, eventID: string) => {
		setFormOpen(true);
		setSelectedMenu(defaultMenuId);
		setSelectedEvent(eventID);
	};

	return (
		<Box padding={2}>
			<Box textAlign="center" padding={3}>
				<Typography variant="h4" color="primary" gutterBottom>
					Classic Wedding Catering Packages
				</Typography>
				<Typography variant="h6" gutterBottom>
					Celebrate your special day with our thoughtfully curated wedding menu packages.
					Delicious dishes, elegant presentation, and seamless service — all at
					transparent prices to suit every budget.
				</Typography>
			</Box>

			<Grid container justifyContent="center">
				<Grid size={{ xs: 12, md: 10 }}>
					<Swiper
						spaceBetween={30}
						slidesPerView={1}
						autoplay={{
							delay: 2500,
							disableOnInteraction: false,
							pauseOnMouseEnter: true,
						}}
						pagination={{
							clickable: true,
						}}
						navigation={true}
						modules={[Autoplay, Pagination, Navigation]}
						className="mySwiper"
						breakpoints={{
							600: {
								slidesPerView: 1,
							},
							900: {
								slidesPerView: 2,
							},
							1200: {
								slidesPerView: 3,
							},
						}}
					>
						{menus.map((menu, index) => (
							<SwiperSlide key={index}>
								<Slide>
									<MenuCard data={menu} handleOpen={handleOpen} />
								</Slide>
							</SwiperSlide>
						))}
					</Swiper>
				</Grid>
			</Grid>

			<GetQuotationForm
				open={formOpen}
				handleClose={handleClose}
				defaultMenuId={selectedMenuId}
				eventID={selectedEvent}
			/>
		</Box>
	);
};

export default MenuContainer2;
